export default "__VITE_ASSET__DBgW96Lt__"